import { useState } from "react";
import { useIsMobile } from "@/hooks/use-mobile";

export const useNeuralNodeInteraction = (
  index: number,
  onHover: (index: number | null) => void
) => {
  const [isHovered, setIsHovered] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const isMobile = useIsMobile();

  const handleMouseEnter = () => {
    if (!isMobile) {
      setIsHovered(true);
      onHover(index);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      setIsHovered(false);
      onHover(null);
    }
  };

  const handleTouch = () => {
    if (isMobile) {
      setIsActive(!isActive);
      onHover(isActive ? null : index);
    } else {
      setShowDetails(!showDetails);
    }
  };

  const handleTouchStart = (e: React.TouchEvent) => {
    e.preventDefault();
    if (isMobile) {
      setIsActive(true);
    }
  };

  const handleTouchEnd = () => {
    if (isMobile) {
      setTimeout(() => setIsActive(false), 150);
    }
  };

  const isInteractive = isHovered || (isMobile && isActive);

  return {
    isHovered,
    showDetails,
    isActive,
    isMobile,
    isInteractive,
    handleMouseEnter,
    handleMouseLeave,
    handleTouch,
    handleTouchStart,
    handleTouchEnd,
  };
};